"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowDiv = exports.ArrowForwardIosIcon = exports.FilterIcon = exports.ButtonFilter = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const framer_motion_1 = require("framer-motion");
exports.ButtonFilter = (0, styled_components_1.default)(core_1.Button) `
  justify-content: flex-start;
  background-color: white;
  padding: 0;
  border-width: 0;
  min-width: fit-content;
  margin-left: 3px;
  font-size: 14px;

  .MuiButton-label {
    color: black;
    font-size: 0.85em;
    width: fit-content;
    font-family: 'ATTAleckSansBold';
    text-transform: none;
    align-items: center;
    gap: 4px;
  }
`;
exports.FilterIcon = (0, styled_components_1.default)(core_1.Icon) `
  width: 16px;
  height: fit-content;
`;
exports.ArrowForwardIosIcon = (0, styled_components_1.default)(icons_1.ArrowForwardIos) `
  height: 20px;
  width: 15px;
`;
exports.ArrowDiv = (0, styled_components_1.default)(framer_motion_1.motion.div) `
  height: 30px;
`;
